module.exports = __webpack_public_path__ + "static/cer_dor_5-6bd7f70977b97ed9c2c3ecba518ca69b.jpg";